import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class TabMenuItemComponent extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,

    id: PropTypes.number.isRequired,
    active: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,

    setVisiblePaneIndex: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    this.handleClick = () => {
      this.props.onClick && this.props.onClick();
      this.props.setVisiblePaneIndex(this.props.id);
    };
  }

  get className () {
    return classNames('item', { active: this.props.active });
  }

  render () {
    return (
      <a onClick={this.handleClick} className={this.className}>
        {this.props.children}
      </a>
    );
  }
}

export default TabMenuItemComponent;
